import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { captureCouponFromUrl } from '../../utils/coupon';
import {
  captureAcquisition,
  identifyAnalyticsUser,
  initAnalytics,
  track,
  trackPageview,
  updateSessionRecordingForRoute,
} from '../../utils/analytics';

const AnalyticsBridge = () => {
  const location = useLocation();
  const { user, billingState, loading } = useAuth();
  const lastAccessRef = useRef(null);

  useEffect(() => {
    initAnalytics().then(() => {
      captureAcquisition();
      trackPageview(location.pathname);
      updateSessionRecordingForRoute(location.pathname);
      if (user) identifyAnalyticsUser(user, billingState);
    });
  }, []);

  useEffect(() => {
    captureCouponFromUrl();
  }, [location.search]);

  useEffect(() => {
    if (!window.posthog) return;
    captureAcquisition();
    trackPageview(location.pathname);
    updateSessionRecordingForRoute(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (loading || !user) return;
    identifyAnalyticsUser(user, billingState);

    const accessKey = `${billingState?.source || 'unknown'}:${billingState?.active === true}:${user.plan_tier || 'rotina'}`;
    if (lastAccessRef.current && lastAccessRef.current !== accessKey) {
      track('access_state_changed', {
        access_active: billingState?.active === true,
        billing_source: billingState?.source || 'unknown',
        plan_tier: user.plan_tier || 'rotina',
      });
    }
    lastAccessRef.current = accessKey;
  }, [user?.id, user?.plan_tier, user?.trial_ends_at, billingState?.source, billingState?.active, loading]);

  return null;
};

export default AnalyticsBridge;
